const { REACT_APP_REPORT_BASE_URL = "https://gdev.gravoc.com" } = process.env;

export default {
  name: "PTO Processing",
  label: "PTO",
  icon: "stopwatch",
  permissions: ["ADMIN", "HR", "PTO"],
  active: location => location.pathname.includes("pto"),
  links: [
    {
      name: "PTO Processing",
      links: [
        {
          name: "New PTO Request",
          to: "/pto/pto-request"
        },
        {
          name: "History",
          to: "/pto/booking-history"
        },
        {
          name: "Balance Report",
          href: ({ supervisorRecIdRef }) =>
            `${REACT_APP_REPORT_BASE_URL}/ReportViewer/ReportViewer.aspx?Path=Employee%20Balance&Param=Supervisor&ParamValue=${supervisorRecIdRef}`
        },
        {
          name: "Activity Report",
          href: ({ supervisorRecIdRef }) =>
            `${REACT_APP_REPORT_BASE_URL}/ReportViewer/ReportViewer.aspx?Path=Employee%20PTO%20Activity&Param=Supervisor&ParamValue=${supervisorRecIdRef}`
        }
      ]
    }
  ]
};
